import { createSelector } from 'reselect';

const selectFundingReport = (state) => state.get('fundingReport');

const makeSelectResendInviteError = () =>
  createSelector(selectFundingReport, (state) => state.getIn(['resendInvite', 'network', 'error']));

const makeSelectResendInviteLoading = () =>
  createSelector(selectFundingReport, (state) =>
    state.getIn(['resendInvite', 'network', 'loading']),
  );

const makeSelectResendInviteSuccess = () =>
  createSelector(selectFundingReport, (state) =>
    state.getIn(['resendInvite', 'network', 'success']),
  );

export {
  makeSelectResendInviteError,
  makeSelectResendInviteLoading,
  makeSelectResendInviteSuccess,
};
